import { getElement } from './functions';
export const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400
};
export const containers = {
  sm: 540,
  md: 720,
  lg: 960,
  xl: 1140,
  xxl: 1320
};
export const baseElements = {
  $html: getElement('html'),
  $header: getElement('.header'),
  $footer: getElement('footer')
};